/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, PureComponent } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";

//import '../../css/event210621.css'

import "../../css/event220617.css";

import { toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
// import { isMobile } from "react-device-detect";

class Event202210_pop extends PureComponent {
  state = {
    success: false,
  };
  componentDidMount = () => {
    this._getData();
  };

  _getData = async () => {
    const result = await this._getDataApi();
    const success = result.data[0].success;
    const intReturn = result.data[0].intReturn;
    const list = result.data[0].listData;

    //console.log(success)

    if (intReturn === 0) {
      this.setState({
        list,
        success,
      });

      //alert(list[0].title + '/' + list[1].title + '/' + list[0].idx + '/' + list[0].regDate)
    } else {
      toast.error("주문내역이 존재하지 않습니다.");
    }
  };

  _getDataApi = () => {
    const { apiUrl } = this.props;

    return axios.post(apiUrl + "/event_202210_list", {
      params: {},
    });
  };
  _close = () => {
    const { close } = this.props.childProps;
    close();
  };
  _renderItem = () => {
    const { list } = this.state;
    //console.log(list)
    const lst = list.map((item, index) => {
      return (
        <dl>
          <dd>{item.title}</dd>
          <dd>{item.liveTime}</dd>
          <dd>{item.genreName}</dd>
        </dl>
      );
    });

    return lst;
  };
  _go = () => {
    window.open(
      "https://docs.google.com/forms/d/e/1FAIpQLSdJ4d9VfD9fFOtk_KRXS8Oh4_y4WJplQNU8V2rV-MlnJBnzPQ/viewform?usp=sf_link",
      "",
      ""
    );
  };
  _reset = () => {
    const { reset } = this.props.childProps;
    reset();
  };
  render() {
    const { list } = this.state; /*success = 0 뽑기성공,  -1 뽑기 실패 */
    //console.log(success)
    return (
      <Fragment>
        <div className="pop_recipt">
          <ul className="popContainer">
            <li className="date">
              <dl>
                <dt>보관일자</dt>
                <dd style={{ paddingLeft: 10 }}>
                  {list ? list[0].regDate : null}
                </dd>
              </dl>
              <dl>
                <dt>보관장소</dt>
                <dd style={{ paddingLeft: 10 }}>ADF 신작보관소</dd>
              </dl>
            </li>
            <li className="user">
              <span>
                <b>No.{list ? list[0].idx : null}</b>의 신작 보관 완료!
              </span>
            </li>
            <li className="list">
              <dl>
                <dt>작품명</dt>
                <dt>방영일자</dt>
                <dt>장르</dt>
              </dl>
              {list ? this._renderItem() : null}
            </li>
            <li className="btm">
              <a
                style={{ cursor: "pointer" }}
                className="link"
                onClick={this._close}
              >
                라인업 확인하기
              </a>
              <a
                style={{ cursor: "pointer" }}
                className="link"
                onClick={this._go}
              >
                구글 폼 응모하기
              </a>
            </li>
          </ul>
          <img src="/img/event/event220916/pop_bg_recipt.png" />
        </div>

        {/*
                <div>
                    <div onClick={this._close}>닫기</div>
                    { list ? this._renderItem() : null }
                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202210_pop));
